module.exports = __webpack_public_path__ + "img/viesonicpc.b33695a7.jpeg";